import { Directive, forwardRef, Input } from '@angular/core';
import { Router } from '@angular/router';
import { of } from 'rxjs';

import { RegisterPermissionType } from '@assetaccountant/api/models/register-permission-type';
import { AuthorizationService } from '../services/authorization.service';
import { AuthorizeRegisterBase } from './authorize-register.base';
import { AUTHORIZERS } from './authorizer';

/**
 * Can use this as
 * - `<ng-template authorizeShow [authorizeRegister]="permission"></ng-template>`
 *   RegisterId is implicit (from route)
 * - `<ng-template authorizeShow [authorizeRegister]="permission" [authorizeRegisterId]="registerId"></ng-template>`
 *   RegisterId is explicit
 * - `<ng-template [authorizeShowElse]="TemplateRef" [authorizeRegister]="permission"></ng-template>`
 *   Show an else template if register is not authorised
 * - `<button authorizeEnable [authorizeRegister]="permission"></button>`
 *   Disable the element instead of hiding it.
 *   Overrides else.
 */
@Directive({
  selector: '[authorizeRegister]',
  providers: [
    {
      provide: AUTHORIZERS,
      useExisting: forwardRef(() => AuthorizeRegisterDirective),
      multi: true,
    },
  ],
  standalone: false,
})
export class AuthorizeRegisterDirective extends AuthorizeRegisterBase {
  @Input('authorizeRegister') permission?: RegisterPermissionType;
  // eslint-disable-next-line @angular-eslint/no-input-rename
  @Input('authorizeRegisterId') registerId?: number;

  constructor(authorizationService: AuthorizationService, router: Router) {
    super(authorizationService, router);
  }
  protected isAuthorizedForRegister(registerId: number) {
    if (!registerId) {
      return of(false);
    }

    if (!this.permission) {
      return of(true);
    }

    return this.isAuthorizedForPermission(registerId, this.permission);
  }
}
